import React, { useCallback, useState, useEffect } from 'react'
import Modal from '@mui/material/Modal';
import ButtonBase from '@mui/material/ButtonBase';
import styles from './DropZoneModal.module.scss';
import ProgressBar from 'components/ui_components/ProgressBar/ProgressBar'
import { useDropzone } from 'react-dropzone'

const DropZoneModal = (props) => {

  const { modalOpen, handleCloseDropZone, handleSubmit, isUploading, handleDropFiles, dropZoneFiles, error } = props;

  const [localError, setLocalError] = useState(false);

  const onDrop = useCallback(acceptedFiles => {
    handleDropFiles(acceptedFiles);
  }, [handleDropFiles])

  useEffect(() => {
    if (dropZoneFiles && dropZoneFiles.length > 0) {
      setLocalError(false);
    }
  }, [dropZoneFiles]);

  useEffect(() => {
    if (!modalOpen) {
      setLocalError(false);
    }
  }, [modalOpen]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <Modal open={modalOpen} onClose={handleCloseDropZone}>
      <div className={`${styles.root} modalContainer`}>

        {isUploading && <div className={styles.progressBar}><ProgressBar/></div>}
        <h2 className="ttl ttl-2">

        </h2>
        <div>
          <div {...getRootProps({ className: styles.dropzone })}>
            <input {...getInputProps()} />
            {
              isDragActive ?
                <p>Drop the files here ...</p> :
                <p>Drag 'n' drop some files here, or click to select files</p>
            }
          </div>

          {(error || localError) && <div className={styles.errorMessage}>
            Please Upload File
          </div>}
          {dropZoneFiles.length > 0 && <aside>
            <h4>Files</h4>
            <ul>
              {dropZoneFiles.map(file => (
                <li key={file.name}>
                  {file.name} - {file.size} bytes
                </li>
              ))}
            </ul>
          </aside>}
        </div>

        <div className={`${'buttonGroup'} ${styles.buttonGroup}`}>
          <ButtonBase
            className="button formButton formButton__secondaryOutlined"
            onClick={handleCloseDropZone}>
            Cancel
          </ButtonBase>
          <ButtonBase
            className="button formButton formButton__mainContained"
            onClick={() => {
              if (!dropZoneFiles || dropZoneFiles.length === 0) {
                setLocalError(true);
                return;
              }
              setLocalError(false);
              handleSubmit();
            }}
          >
            Add
          </ButtonBase>
        </div>
      </div>
    </Modal>
  );
}

export default DropZoneModal;